/**
 * Mobile route path constants (relative to the `/:client` prefix).
 *
 * Mobile mirrors the desktop `/:client/...` URL scheme so shared helpers
 * (`getClientPrefix`, `useNavigateWithClient`) and existing deep links keep
 * working unchanged.
 *
 * A path listed here with `built: false` means the screen is not ported to
 * mobile yet — the router falls back to <NotAvailable/> for it. Flip to
 * `built: true` (and add the <Route/>) as each screen ships.
 */
export const MOBILE_ROUTES = {
  DASHBOARD: 'home',
  PERFORMANCE: 'performance',
  PROFILE: 'profile',
};

export const MOBILE_NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', path: '/home', built: true },
  { key: 'performance', label: 'Performance', path: '/performance', built: true },
  { key: 'profile', label: 'Profile', path: '/profile', built: true },
];
